import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["step", "buttons", "box", "next"];
  static values = { start: Number };

  connect() {
    this.show(this.startValue);
    this.toggle();
  }

  toggle() {
    this.nextTarget.disabled = !this.boxTarget.checked;
  }

  next() {
    this.show(2);
  }

  back() {
    this.show(1);
  }

  wait() {
    this.show(3);
  }

  show(step) {
    [...this.stepTargets, ...this.buttonsTargets].forEach((panel) => {
      panel.hidden = Number(panel.dataset.step) !== step;
    });
  }
}
